import { useParallax } from "react-scroll-parallax";

import { ReactSVG } from "react-svg";

import knight from "../assets/svg/knight.svg";

const Intro = () => {
	const parallax = useParallax({
		speed: -5,
	});

	return (
		<section className="z-10 flex max-w-5xl flex-col-reverse items-center justify-center gap-15 px-6 py-15 md:grid md:grid-cols-2 md:py-35">
			<div className="flex w-full flex-col gap-6 text-white">
				<h2 className="font-serif text-4xl leading-[1.3] uppercase lg:text-5xl">
					Friulana di madre,
					<br />
					San Giorgio di&nbsp;padre
				</h2>
				<p className="max-w-md text-lg lg:text-xl">
					Così nasce <strong>San Zorz</strong>, nel birrificio <strong>San Giorgio di Nogaro</strong> dalle laboriose
					mani dei mastri birrai.
				</p>
				<p className="max-w-md text-lg lg:text-xl">
					Una birra che nel suo nome riporta la <strong>dedizione</strong>, la <strong>passione</strong> e la{" "}
					<strong>decisione</strong> dei friulani.
				</p>
			</div>
			<div ref={parallax.ref}>
				<ReactSVG src={knight} className="[&_svg]:h-auto [&_svg]:w-[70vw] [&_svg]:md:w-full" />
			</div>
		</section>
	);
};

export default Intro;
